<div class="main-content">


  <!-- <div nz-row nzJustify="start" [nzGutter]="[8,8]">
    <div nz-col [nzXs]="{ span: 10, offset: 0 }" [nzLg]="{ span: 3, offset: 0 }">
      <app-operator-dropdown (operatorEvent)="operatorEvent($event)"></app-operator-dropdown>
    </div>
    <div nz-col [nzXs]="{ span: 11, offset: 0 }" [nzLg]="{ span: 3, offset: 0 }">
      <app-merchant-dropdown [operator]="operator"
        (onSelectMerchant)="onSelectMerchant($event)"></app-merchant-dropdown>
    </div>
    <div nz-col [nzXs]="{ span: 10, offset: 0 }" [nzLg]="{ span: 3, offset: 0 }">
      <app-packages [clear]="(!operator && !merchant)" [operator]="operator" [merchant]="merchant"
        (onSelectPlan)="getSelectedPlans($event)"></app-packages>
    </div>
    <div nz-col [nzXs]="{ span: 3, offset: 0 }" [nzLg]="{ span: 3, offset: 0 }">
      <button nz-button nzType="primary" (click)="loadOperatorDetails()">
        <span nz-icon nzType="search"></span>
        Search
      </button>
    </div>
  </div> -->



  <div class="d-flex-filter">
    <app-operator-dropdown (operatorEvent)="operatorEvent($event)"></app-operator-dropdown>
    <app-merchant-dropdown [operator]="operator" (onSelectMerchant)="onSelectMerchant($event)"></app-merchant-dropdown>
    <app-packages [clear]="(!operator && !merchant)" [operator]="operator" [merchant]="merchant"
      (onSelectPlan)="getSelectedPlans($event)"></app-packages>

    <button nz-button nzType="primary" (click)="loadOperatorDetails()">
      <span nz-icon nzType="search"></span>
      Search
    </button>
  </div>


  <nz-table [nzLoading]="loading" style="padding-top: 20px;" #smallTable nzSize="small" [nzData]="operatorDetails"
    [nzScroll]="{ x: '1100px' }">
    <thead>
      <tr>
        <th>Date</th>
        <th>Plan</th>
        <th>Plan Id</th>
        <th>Amount</th>
        <th>Activation</th>
        <th>Churn</th>
        <th>Renewal</th>
        <th>Toatal base</th>
        <th>Revenue</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of smallTable.data; index as i">
        <td>{{ data.date | date }}</td>
        <td>{{ data.plan }}</td>
        <td>{{ data.serviceId }}</td>
        <td>{{ data.chargeAmount }}</td>
        <td>{{ data.newActive }}</td>
        <td>{{ data.churn }}</td>
        <td>{{ data.renewalTotalSuccess }}</td>
        <td>{{ data.totalBase }}</td>
        <td>{{ data.revenue }}</td>
      </tr>
      <ng-container *ngIf="operatorDetails && operatorDetails.length > 0">
        <tr>
          <td>Total</td>
          <td colspan="3"></td>
          <td>{{ getTotalActivation() }}</td>
          <td>{{ getTotalChurn() }}</td>
          <td>{{ getTotalRenewal() }}</td>
          <td>{{ getTotalBase() }}</td>
          <td>{{ getTotalRevenue() }}</td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>




  <br>

  <div class="d-flex-archive-filter">
    <nz-range-picker [(ngModel)]="date" (ngModelChange)="onDateRangeChange($event)"></nz-range-picker>
    <span style="padding-left: 10px;"></span>
    <button nz-button nzType="primary" (click)="onArchiveSearch()">
      <span nz-icon nzType="search"></span>
      Search
    </button>
  </div>






  <nz-table [nzLoading]="archiveLoading" style="padding-top: 20px;" #summaryArchiveTable nzSize="small"
    [nzData]="operatorDetailsArchive" [nzScroll]="{ x: '1100px' }">
    <thead>
      <tr>
        <th>Date</th>
        <th>Plan</th>
        <th>Plan Id</th>
        <th>Amount</th>
        <th>Activation</th>
        <th>Churn</th>
        <th>Renewal</th>
        <th>Toatal base</th>
        <th>Revenue</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of summaryArchiveTable.data">
        <td>{{ data.date | date }}</td>
        <td>{{ data.plan }}</td>
        <td>{{ data.serviceId }}</td>
        <td>{{ data.chargeAmount }}</td>
        <td>{{ data.newActive }}</td>
        <td>{{ data.churn }}</td>
        <td>{{ data.renewalTotalSuccess }}</td>
        <td>{{ data.totalBase }}</td>
        <td>{{ data.revenue }}</td>
      </tr>
      <ng-container *ngIf="operatorDetailsArchive && operatorDetailsArchive.length > 0">
        <tr>
          <td>Total</td>
          <td colspan="3"></td>
          <td>{{ getArchiveTotalActivation() }}</td>
          <td>{{ getArchiveTotalChurn() }}</td>
          <td>{{ getArchiveTotalRenewal() }}</td>
          <td>{{ getArchiveTotalBase() }}</td>
          <td>{{ getArchiveTotalRevenue() }}</td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>